import React from 'react';
import styles from './Field.module.css';
import {Field, useField} from 'formik';
import { ReactComponent as CheckedIcon } from '../../icons/unchecked.svg';
import { ReactComponent as UncheckedIcon } from '../../icons/checked.svg';


const FieldCheckboxArray = ({ label, name, value, onChange }) => {
    const [field, meta, helpers] = useField(name);

    const isChecked = Array.isArray(field.value) ? field.value.includes(value) : field.value;

    const handleChange = (e) => {
        if (Array.isArray(field.value)) {
            const set = new Set(field.value);
            if (e.target.checked) {
                set.add(e.target.value);
            } else {
                set.delete(e.target.value);
            }
            helpers.setValue([...set]);
        } else {
            helpers.setValue(e.target.checked);
        }
        if (onChange) onChange(e);
    };

    return (
        <div className={`${styles.field} ${styles.checkbox}`}>
            <label htmlFor={value}>
                <input
                    type="checkbox"
                    name={name}
                    id={value}
                    value={value}
                    checked={isChecked}
                    onChange={handleChange}
                />
                {isChecked ? <UncheckedIcon/> : <CheckedIcon/>}
                {label}
            </label>
            {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
        </div>
    );
};

export default FieldCheckboxArray;
